import React from "react";
import { useNavigate } from "react-router-dom";

export const scrollToContact = () => {
  const contactSection = document.getElementById("contact-section");
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: "smooth" });
  }
};

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section style={styles.hero}>
      <div style={styles.overlay}>
        <div style={styles.content}>
          <span style={styles.badge}>Trusted by 500+ Clients</span>
          <h1 style={styles.heading}>
            India's Best{" "}
            <span style={styles.gradientText}>Crypto Consulting Services</span>
          </h1>

          <p style={styles.text}>
            We help Crypto investors at every level across the world. From
            beginners to experienced traders, we guide you with the right
            knowledge, smart strategies, and real market insights.
            <br />
            <br />
            Crypto offers big gains—but without guidance, losses come just as
            fast. We guide you with clarity and confidence.
          </p>

          <div style={styles.buttonGroup}>
            <button style={styles.primaryButton} onClick={scrollToContact}>
              Book a Consultation
            </button>
            <button
              style={styles.secondaryButton}
              onClick={() => navigate("/services")}
            >
              View Services
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    minHeight: "90vh",
    backgroundImage: "url('/hero.webp')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    fontFamily: "'Inter', sans-serif",
  },

  overlay: {
    width: "100%",
    minHeight: "90vh",
    background:
      "linear-gradient(90deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 100%)",
    display: "flex",
    alignItems: "center",
    padding: "0 5%",
  },

  content: {
    color: "white",
    maxWidth: "700px",
    // Adding some padding for mobile safety
    padding: "20px",
  },

  badge: {
    display: "inline-block",
    padding: "6px 14px",
    backgroundColor: "rgba(236, 72, 153, 0.15)",
    color: "#f472b6",
    borderRadius: "20px",
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "20px",
    border: "1px solid rgba(236, 72, 153, 0.3)",
  },

  heading: {
    fontSize: "clamp(2.5rem, 5vw, 4rem)", // Responsive font sizing
    fontWeight: "800",
    lineHeight: "1.1",
    marginBottom: "24px",
  },

  gradientText: {
    background: "linear-gradient(to right, #ec4899, #8b5cf6)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  text: {
    fontSize: "clamp(1rem, 2vw, 1.25rem)",
    lineHeight: "1.7",
    color: "#d1d5db",
    marginBottom: "35px",
  },

  buttonGroup: {
    display: "flex",
    gap: "15px",
    flexWrap: "wrap",
  },

  primaryButton: {
    padding: "16px 32px",
    fontSize: "16px",
    fontWeight: "600",
    backgroundColor: "#ec4899",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "transform 0.2s ease",
    boxShadow: "0 10px 15px -3px rgba(236, 72, 153, 0.3)",
  },

  secondaryButton: {
    padding: "16px 32px",
    fontSize: "16px",
    fontWeight: "600",
    backgroundColor: "transparent",
    color: "white",
    border: "1px solid rgba(255,255,255,0.3)",
    borderRadius: "8px",
    cursor: "pointer",
    backdropFilter: "blur(5px)",
  },
};

export default Hero;
